"use strict";

exports.__esModule = true;
exports.AddColumnField = AddColumnField;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Pull out the columns from the definition not currently used on the table
function getColumnsFromDefinition(props) {
  var dataSourceDefinition = props.dataSourceDefinition;
  return dataSourceDefinition.columns.map(function (item) {
    return {
      id: item.id,
      name: item.name
    };
  });
}
function handleAddColumn(props, item) {
  var dataSourceDefinition = props.dataSourceDefinition,
    onAddColumn = props.onAddColumn;
  var definition = dataSourceDefinition.columns.find(function (columnDefinition) {
    return columnDefinition.id === item.id;
  });
  if (definition && onAddColumn) {
    onAddColumn(definition);
  }
}
function getKey(input) {
  return input.id;
}
function renderItemText(input) {
  return input.name;
}
function itemPredicate(query, device) {
  var q = query.toLowerCase();
  return device.id.toLowerCase().indexOf(q) !== -1 || device.name.toLowerCase().indexOf(q) !== -1;
}
function AddColumnField(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var columns = getColumnsFromDefinition(props);
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    helperText: translate("DataTableFields.columns.helperText", "Hide/show columns and re-order.")
  }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
    dataTestId: "AddColumnField.selector",
    filterable: false,
    onSelect: function onSelect(items) {
      return handleAddColumn(props, items[0]);
    },
    items: columns,
    getKey: getKey,
    renderItemText: renderItemText,
    itemPredicate: itemPredicate
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "AddColumnField.button",
    text: translate("DataTableFields.columns.addLabel", "Add Column"),
    icon: _icons.IconNames.ADD_COLUMN_RIGHT
  })));
}